import { Container, Point, Ticker } from 'pixi.js'
import SmokeParticle from './SmokeParticle'

export default class SmokeStream extends Container {
  private puffs: SmokeParticle[] = []

  constructor(position: Point, baseAlpha: number, strength: number, tint: number = 0xffffff) {
    super()
    this.zIndex = 4

    this.position.set(position.x, position.y)
    for (let i = 0; i < strength; i++) {
      this.puffs.push(new SmokeParticle(this, 260, baseAlpha, tint))
    }
    const ticker = Ticker.shared
    ticker.add(() => this.loop())
  }

  private loop(): void {
    this.puffs.forEach((puff) => puff.move())
  }
}
